import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';

import { AppMainService } from '../../../../app-main.service';
import { AppMainComponent } from '../../../../app.main.component';
import { LeadService } from '../../../../leads/leadService';
import { OpportunityService } from '../../../../opportunities/opportunity.service';
import { Case } from '../../../../cases/model/case';
import { CasesService } from '../../../../cases/cases.service';
import { Status } from '../../../../models/statusEnums';
import { noWhitespaceValidator } from '../../validators/custom.required';
import { CaseService } from 'src/app/configurations/crm/case/case.service';
import { OpportunitiesService } from 'src/app/opportunities-v2/services/opportunity.service';
import { ObjectNames, ObjectTypeId } from 'src/app/shared/constants';
import { CaseModuleId, OpportunityModuleId } from '../../constants/modules.constant';
import { UserService } from 'src/app/service/userservice';
import { CrmSettingsService } from '../../services/crm-settings.service';
import { CrmSettingModel } from 'src/app/configurations/models/organization-settings.model';
import { StageOnwerSettingCode } from '../../constants/stage-owner-setting.constants';

@Component({
    selector: 'app-lion-comment-modal',
    styleUrls: ['./app.comment.modal.component.scss'],
    templateUrl: './app.comment.modal.component.html',
})
export class LionAppCommentModalComponent implements OnInit, OnChanges {

    commentForm: FormGroup;
    options: any[];
    items: MenuItem[] = [];
    icon = "fa fa-thumb-tack fa-rotate-90";
    ownerList: any[] = [];
    leadOwnerSettings: any = {};
    closeDateTitle: string;
    constructor(
        private fb: FormBuilder,
        public app: AppMainComponent,
        private caseService: CasesService,
        private leadService: LeadService,
        private messageService: MessageService,
        private opportunityService: OpportunityService,
        private confirmationService: ConfirmationService,
        private appMainService: AppMainService,
        private caseConfigService: CaseService,
        private opportunityServiceV2: OpportunitiesService,
        public userService: UserService,
        private crmSettingsService: CrmSettingsService,
    ) { }

   // @Input() isCase: boolean = false;;
    @Input() showPublicPrivateBtn: boolean = false;
    @Input() displayCommentAdd: boolean;
    @Input() selectedCase: Case;
    @Input() tempComment: any;
    @Input() nextStageId: number;
    @Input() commentFormType: string;
    @Input() caseStagesAll: any;
    @Input() readPermission: boolean;
    @Input() editPermission: boolean;
    @Input() deletePermission: boolean;
    @Input() commentHeaderTitle: string;
    @Input() objectType: string;
    @Input() selectedCaseComment;
    @Input() callFromTimeLine:boolean = false;
    @Output() commentCancelClicked = new EventEmitter();
    @Output() commentSaved = new EventEmitter();
    @Output() commentDeleted = new EventEmitter();

    currentCase: Case;
    currentComment;
    currentShowPublicPrivateBtn: boolean;
    resolution: boolean = false;
    notify: boolean = false;

    nextStageIdToUpdate: number;
    formType: string;
    caseStages: any;
    currentHeaderTitle: string = "";
    currentObjectType;
    disabledAddComment: boolean = false;
    isClosed: boolean = false;
    closedStages = [];
    closeLostUnQualifiedReasons = [];
    closeWonQualifiedReasons = [];
    closeLostUnQualifiedTitle = '';
    closeWonQualifiedTitle = '';
    isSubmit = false;
    closeWonStage = null;
    closeLostStage = null;
    //isConvert = false;

    // Case Resolved Unresolved
    resolvedReasons: Array<any>;
    unResolvedReasons: Array<any>;
    showResolvedUnresolvedArea: boolean = false;

    resolvedUnresolvedStages: Array<any>;

    resolvedReasonTitle: string = '';
    unresolvedReasonTitle: string = '';
    showResolvedReasonsList: boolean = false;
    showUnResolvedReasonsList: boolean = false;

    showResolvedUnresolvedReasons: boolean = false;
    resolvedUnresolvedReasonList: Array<any>;
    closedReasonTitle: string = '';
    closeStages: string[] = ["Qualified","UnQualified","Closed Won","Closed Lost","Resolved","UnResolved"]
    ngOnInit() {
        this.items.push({
            label: "View",
            icon: "pi pi-eye",
            disabled: this.formType == 'View',
            command: () => {
                this.formType = 'View';
            }
        })
        if (this.currentComment && this.currentComment.createdBy == this.app.user.userId) {
            this.items.push({
                label: "Edit",
                icon: "pi pi-pencil",
                disabled: this.formType == 'Edit',
                command: () => {
                    this.formType = 'Edit';
                    if(!this.isClosed){
                        this.commentForm.get('closedDate').clearValidators();
                    }
                    this.currentComment.isPublicOption = this.currentComment.isPublic ? { label: 'Public', value: true } : { label: 'Private', value: false };
                    this.currentComment.closedDate = this.currentComment.closedDate ? this.app._showDateTimeWithZone(this.currentComment.closedDate) : '';
                    this.closeDateTitle = this.currentComment?.stage?.name;
                    this.commentForm.patchValue(this.currentComment);
                    this._updateStage();
                }
            })
            this.items.push({
                label: "Delete",
                icon: "pi pi-trash",
                visible: false, //Delete not working
                command: () => {
                    this.confirmationService.confirm({
                        message: 'Do you want to delete this Comment?',
                        header: 'Delete Confirmation',
                        icon: 'pi pi-info-circle',
                        accept: () => {
                            // same api used for delete case, lead, apporunity
                            this.caseService.deleteCaseComment(this.currentComment.id).subscribe(
                                (resp) => {
                                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                                    this.commentDeleted.emit({
                                        formType: this.formType,
                                        comment: this.tempComment,
                                        objectRecordId: this.currentCase.id
                                    });
                                    this.app.getAllObjects();
				                    //this.app.getAllActivityLog("thisyear", "allactivity", 1, 10, "", true, true);
                                },
                                (err) => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' })
                            );
                        },
                        reject: () => {
                        }
                    });
                }
            })
        }


        this.currentCase = this.selectedCase ?  this.selectedCase : this.selectedCaseComment;
        this.currentComment = this.tempComment;
        this.nextStageIdToUpdate = this.nextStageId;
        this.caseStages = this.caseStagesAll;
        this.options = [{ label: 'Private', value: false }, { label: 'Public', value: true }];
        this.commentForm = this.fb.group({
            id: [0],
            createdSource: [this.app.user.userIP],
            updatedSource: [this.app.user.userIP],
            createdBy: [this.app.user.userId],
            updatedBy: [this.app.user.userId],
            createdDate: [this.currentCase?.createdDate || new Date()],
            updatedDate: [new Date()],
            organizationId: this.app.user.organizationId,
            objectRecordId: [0],
            objectId: [this.tempComment?.objectId],
            comment: ['', [Validators.required, noWhitespaceValidator]],
            stageId: [''],
            isPublic: [true],
            statusId: [Status.Active],
            isPublicOption: [{ label: 'Private', value: false }],
            reasonId: null,
            objectStageAuditReason: null,
            notifyClient: [false],
            resolvedUnresolvedStage: [''],
            resolvedUnresolvedReasons: ['', Validators.required],
            stageOwnerId: [null],
            closedDate: [this.currentCase?.closedDate ? this.app._showDateTimeWithZone(this.currentCase.closedDate) : new Date(), Validators.required],
        });

        this._updateClosedObject();
        this.isSubmit = false;

        if (this.nextStageIdToUpdate == -1 && this.currentObjectType == "Case"){
            this.getResolvedReason();
            if (this.currentCase['closedStages']){
                const data = this.currentCase['closedStages'];
                this.resolvedUnresolvedStages = [...data];
                const selectedStage = data ? data.filter(x => x?.name == "Resolved") : [];
                this.commentForm.patchValue({ resolvedUnresolvedStage: selectedStage[0] });
            }
            //this.getUnresolvedReason();
            this.showResolvedUnresolvedArea = true;
        }

        // Clear the validation of resolved unresolved multi select when other stage open rather than closed stage
        if (this.currentObjectType == "Case" && this.nextStageIdToUpdate != -1){
            this.getResolvedUnresolvedReasons.clearValidators();
            this.getResolvedUnresolvedReasons.updateValueAndValidity();
        }

        if (this.tempComment?.objectType == 'Case' && this.tempComment?.objectStageAuditReason?.length > 0){
            this.showResolvedUnresolvedReasons = true;
            this.isClosed = true;
            this.currentComment.closedDate = this.currentCase?.closedDate||null;
            let resolvedUnresolvedStages = this.currentCase['closedStages'];
            let stage = resolvedUnresolvedStages?.filter(x => x.id == this.currentComment?.stageId).map(x => x?.name);
            if (stage?.[0] == "Resolved" || this.currentComment?.stage?.name=="Resolved"){
                this.getResolvedReason(true, this.tempComment?.objectStageAuditReason);
            }
            else {
                this.getUnresolvedReason(true, this.tempComment?.objectStageAuditReason);
            }

        }

        if (this.tempComment?.objectType == 'Case'){
            this.closedStages = this.currentCase['closedStages'];
            this.currentShowPublicPrivateBtn = true;
        }

        if (this.currentObjectType == "Lead" || this.currentObjectType == "Opportunity"){
            this.getResolvedUnresolvedReasons.clearValidators();
            this.getResolvedUnresolvedReasons.updateValueAndValidity();
        }
        this.closeDateTitle = this.closedStages?.length > 0 ? this.closedStages[0].name : '';
        this.getUserList();
        // this.getSettingsData();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes.showPublicPrivateBtn && changes.showPublicPrivateBtn.currentValue != undefined) {
            this.currentShowPublicPrivateBtn = changes.showPublicPrivateBtn.currentValue;
        }
        if (changes.selectedCase && changes.selectedCase.currentValue) {
            this.currentCase = changes.selectedCase.currentValue;
        }

        if (changes.nextStageId && changes.nextStageId.currentValue) {
            this.nextStageIdToUpdate = changes.nextStageId.currentValue;
        }

        if (changes.commentFormType && changes.commentFormType.currentValue) {
            this.formType = changes.commentFormType.currentValue;
        }

        if (changes.commentHeaderTitle && changes.commentHeaderTitle.currentValue) {
            this.currentHeaderTitle = changes.commentHeaderTitle.currentValue;
        }

        if (changes.objectType && changes.objectType.currentValue) {
            this.currentObjectType = changes.objectType.currentValue;
        }


        if (changes.tempComment && changes.tempComment.currentValue) {
            this.currentComment = changes.tempComment.currentValue;
        }
        if (changes.caseStagesAll && changes.caseStagesAll.currentValue) {
            this.caseStages = changes.caseStagesAll.currentValue
        }
        if (changes.callFromTimeLine && changes.callFromTimeLine.currentValue) {
            this.caseStages = changes.callFromTimeLine.currentValue
        }


    }

    _updateClosedObject() {
        this.closeLostStage = this.closeWonStage = null;
        this.isClosed = false;
        if (this.tempComment?.objectId == 3 || this.tempComment?.objectId == 1) {
            this.closedStages = this.currentCase?.closedStages ? this.currentCase?.closedStages :
                this.currentCase?.selectedStages ? this.currentCase?.selectedStages.filter(x => x.probability == 0 || x.probability == 100) : [];
            this.isClosed = this.nextStageIdToUpdate == -1 ? true :
                this.closedStages.find(x => x.id == this.nextStageIdToUpdate) ? true : false;
            if (this.isClosed) {
                this.closeLostStage = this.closedStages.find(x => x.probability == 0);
                this.closeWonStage = this.closedStages.find(x => x.probability == 100);
                switch (this.tempComment.objectId) {
                    case 1:
                        //this.isConvert = this.currentCase['isConvert'] ? this.currentCase['isConvert'] : false;
                        this.closeLostUnQualifiedTitle = 'UnQualified Reason';
                        this.closeWonQualifiedTitle = 'Qualified Reason'
                        this.getQualifyReasons('Qualified');
                        this.getQualifyReasons('Un-Qualified');
                        break;
                    case 3:
                        this.closeLostUnQualifiedTitle = 'Close Lost Reason';
                        this.closeWonQualifiedTitle = 'Close Won Reason'
                        this.getClosedReasons("LostReason");
                        this.getClosedReasons("WonReason");
                        break;
                    default:
                        break;
                }
            }
        }
    }

    _updateStage() {
        if ((this.tempComment.objectId == 3 || this.tempComment.objectId == 1) && this.isClosed) {
            if (this.currentComment.stageId) {
                let reasons = null;
                let reasonList = null;

                let stage = (this.currentComment.stageId == this.closeLostStage.id) ?
                    this.closeLostStage : this.closeWonStage;

                if (this.currentComment.objectStageAuditReason && this.currentComment.objectStageAuditReason.length > 0) {
                    reasons = this.currentComment.objectStageAuditReason.map(x => x.reasonId);
                    if ((this.currentComment.stageId == this.closeLostStage.id)) {
                        reasonList = this.closeLostUnQualifiedReasons.filter(x => reasons && reasons.find(y => y == x.id));
                    } else {
                        reasonList = this.closeWonQualifiedReasons.filter(x => reasons && reasons.find(y => y == x.id));
                    }
                }

                this.commentForm && this.commentForm.patchValue({ stageId: stage, reasonId: reasonList });
            } else {
                this.commentForm && this.commentForm.patchValue({ stageId: this.closeWonStage, reasonId: this.closeWonQualifiedReasons.filter(x => x.isDefault) });
            }
        }
    }

    get comment() {
        return this.commentForm?.get('comment');
    }

    get getResolvedUnresolvedReasons() {
        return this.commentForm?.get('resolvedUnresolvedReasons');
    }

    cancelComment() {

        this.commentCancelClicked.emit({
            formType: this.formType,
            ticketId: this.currentCase?.id
        });
        setTimeout(() => {
            this.commentForm.reset();
        })
    }

    getStageName(stageId: number) {
        const filteredStage = this.caseStages.find(stage => stage.stageId ? stage.stageId === stageId : stage.id === stageId);
        const closedStage = this.closedStages.find(stage => stage.stageId ? stage.stageId === stageId : stage.id === stageId);
        if (filteredStage) {
            return filteredStage.name;
        } else if (closedStage) {
            return closedStage.name;
        } else {
            return null;
        }
    }

    // getClosedReasons(groupId) {
    //     this.appMainService.isShowSpinner('getClosedReasons')
    //     this.opportunityService.getClosedReasons(groupId).subscribe(
    //         closedReason => {
    //             this.appMainService.isHideSpinner('getClosedReasons');
    //             if (groupId == 7) {
    //                 this.closeLostUnQualifiedReasons = closedReason;
    //             } else {
    //                 this.closeWonQualifiedReasons = closedReason;
    //             }
    //             this._updateStage();
    //         },
    //         err => {
    //             this.appMainService.isHideSpinner('getClosedReasons')
    //         })
    // }

    getClosedReasons(groupName) {
        this.appMainService.isShowSpinner('getClosedReasons')
        this.opportunityService.getActiveInactiveDataByName(groupName).subscribe(
          // data => {
          //   this.appMainService.isHideSpinner('getClosedReasons');
          //   if (groupId == 7) {
          //     this.closeLostReasons = closedReason ? closedReason : [];
          //   } else {
          //     this.closeWonReasons = closedReason ? closedReason : [];
          //   }
            dataName => {
              this.appMainService.isHideSpinner('getClosedReasons');
              dataName &&
                  this.opportunityService.getActiveInactiveReasons(dataName.id).subscribe(
                      res => {
                          if (groupName == 'LostReason') {
                              this.closeLostUnQualifiedReasons = res ? res : [];
                              this.closeLostUnQualifiedReasons.sort((a, b) => a.name.localeCompare(b.name));
                          } else {
                              this.closeWonQualifiedReasons = res ? res : [];
                              this.closeWonQualifiedReasons.sort((a, b) => a.name.localeCompare(b.name));
                          }
                          this._updateStage();
                      },
                      () => {
                          this.appMainService.isHideSpinner('getClosedReasons');
                      });
          },
          err => {
            this.appMainService.isHideSpinner('getClosedReasons');
          })

      }

    getQualifyReasons(groupName) {
        this.appMainService.isShowSpinner('getQualifyReasons')
        this.leadService.getQualifyDataByName(groupName).subscribe(
            dataName => {
                this.appMainService.isHideSpinner('getQualifyReasons');
                dataName &&
                    this.leadService.getQualifyReasons(dataName.id).subscribe(
                        res => {
                            if (groupName == 'Qualified') {
                                this.closeWonQualifiedReasons = res ? res.filter(x => x.statusId == 1) : [];
                            } else {
                                this.closeLostUnQualifiedReasons = res ? res.filter(x => x.statusId == 1) : [];
                            }
                            this._updateStage();
                        },
                        err => {
                            this.appMainService.isHideSpinner('getQualifyReasons');
                        });
            },
            err => {
                this.appMainService.isHideSpinner('getQualifyReasons');
            })
    }


    saveComment() {
        this.isSubmit = true;
        this.commentForm.value.closedDate = this.app._saveDateTimeWithZone(new Date(new Date(this.commentForm?.value?.closedDate).setHours(23,59,59)));
        const formData = this.commentForm.value;
        const oneCase = {
            ...formData,
            isPublic: formData.isPublicOption.value,
            objectRecordId: this.currentCase?.id,
            stageId: this.nextStageIdToUpdate,
            objectStageAuditReason: null
        };
        this.disabledAddComment = true;
        if(this.objectType == "Case"){
            oneCase.objectId = 8
        }
        if (oneCase.objectId == 8) {
            // cases
            let reasonIds = [];
            if (this.nextStageIdToUpdate == -1){
                reasonIds = formData?.resolvedUnresolvedReasons.map(x => x.id).sort((a, b) => a -b);
            }
            const caseData = {
                ticketId: this.currentCase?.id == undefined ? this.app.objectId : this.currentCase?.id,
                stageId: this.nextStageIdToUpdate == -1 ? formData.resolvedUnresolvedStage?.id : this.nextStageIdToUpdate,
                comment: formData.comment,
                isPublicComment: formData.isPublicOption.value,
                notifyClient: formData.notifyClient,
                isResolution: false,
                reasonIds: this.nextStageIdToUpdate == -1 ? reasonIds : [],
                closedDate: oneCase?.closedDate,
            }
            this.appMainService.isShowSpinner('updateStage');
            this.caseService.updateTicketStage(caseData).subscribe(
                (comment) => {
                    this.appMainService.isHideSpinner('updateStage');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Stage updated successfully...' });
                    this.commentForm.reset();
                    this.commentSaved.emit({
                        formType: this.formType,
                        // comment: comment,
                        // objectRecordId: this.currentCase.id
                        stageId: this.nextStageIdToUpdate
                    });
                    //this.app.getAllObjects();
                    //this.app.getAllActivityLog("thisyear", "allactivity", 1, 10, "", true, true);
                    this.disabledAddComment = false;
                },
                err => {
                    this.appMainService.isHideSpinner('updateStage');
                    this.disabledAddComment = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.errors.Comment[0] })
                }
            );
        } else if (oneCase.objectId == 1) {
            // lead
            if (this.isClosed) {
                if (formData.stageId && formData.stageId.id && formData.stageId.id == this.closeLostStage.id && (!formData.reasonId || formData.reasonId.length == 0)) {
                    this.disabledAddComment = false;
                    return;
                }

                if (formData.stageId && formData.stageId.id && formData.stageId.id == this.closeWonStage.id && (!formData.reasonId || formData.reasonId.length == 0)) {
                    this.disabledAddComment = false;
                    return;
                }

                oneCase.stageId = formData.stageId && formData.stageId.id ? formData.stageId.id : this.nextStageIdToUpdate;

                if (formData.reasonId && formData.reasonId.length) {
                    let objectStageAuditReason = [];
                    let reasons = formData.reasonId.map(x => x.id);
                    reasons = reasons.filter(x => x);
                    reasons.forEach(x => {
                        objectStageAuditReason.push({
                            "id": 0,
                            "createdSource": this.app.user.userIP,
                            "updatedSource": this.app.user.userIP,
                            "createdBy": this.app.user.userId,
                            "updatedBy": this.app.user.userId,
                            "createdDate": new Date(),
                            "updatedDate": new Date(),
                            "objectStageAuditId": 0,
                            "reasonId": x
                        });

                    });
                    oneCase.reasonId = null;
                    oneCase.objectStageAuditReason = objectStageAuditReason;
                } else {
                    oneCase.reasonId = null;
                    oneCase.objectStageAuditReason = null;
                }
            }

            // if (this.isConvert && this.isClosed) {
            //     this.disabledAddComment = false;
            //     this.commentForm.reset();
            //     this.commentSaved.emit({
            //         formType: this.formType,
            //         comment: oneCase,
            //         objectRecordId: this.currentCase.id,
            //         isConvert: true
            //     });
            // } else {
            this.appMainService.isShowSpinner('updateStage');
            this.leadService.updateLeadStageWithComment(oneCase).subscribe(
                (comment) => {
                    this.appMainService.isHideSpinner('updateStage');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Stage updated successfully...' });
                    this.commentForm.reset();
                    this.commentSaved.emit({
                        formType: this.formType,
                        comment: oneCase,
                        objectRecordId: this.currentCase.id
                    });
                    this.disabledAddComment = false;
                },
                err => {
                    this.appMainService.isHideSpinner('updateStage');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.errors.Comment[0] })
                    this.disabledAddComment = false;
                });
            // }
        } else if (oneCase.objectId == 3) {
            // opportunity
            if (this.isClosed) {
                if (formData.stageId && formData.stageId.id && formData.stageId.id == this.closeLostStage.id && (!formData.reasonId || formData.reasonId.length == 0)) {
                    this.disabledAddComment = false;
                    return;
                }

                if (formData.stageId && formData.stageId.id && formData.stageId.id == this.closeWonStage.id && (!formData.reasonId || formData.reasonId.length == 0)) {
                    this.disabledAddComment = false;
                    return;
                }

                oneCase.stageId = formData.stageId && formData.stageId.id ? formData.stageId.id : this.nextStageIdToUpdate;

                if (formData.reasonId && formData.reasonId.length) {
                    let objectStageAuditReason = [];
                    let reasons = formData.reasonId.map(x => x.id);
                    reasons = reasons.filter(x => x);
                    reasons.forEach(x => {
                        objectStageAuditReason.push({
                            "id": 0,
                            "createdSource": this.app.user.userIP,
                            "updatedSource": this.app.user.userIP,
                            "createdBy": this.app.user.userId,
                            "updatedBy": this.app.user.userId,
                            "createdDate": new Date(),
                            "updatedDate": new Date(),
                            "objectStageAuditId": 0,
                            "reasonId": x
                        });

                    });
                    oneCase.reasonId = null;
                    oneCase.objectStageAuditReason = objectStageAuditReason;
                } else {
                    oneCase.reasonId = null;
                    oneCase.objectStageAuditReason = null;
                }
            }
            oneCase.createdDate = new Date();
            this.appMainService.isShowSpinner('updateStage');
            this.opportunityService.updateOpporunityStageWithComment(oneCase).subscribe(
                (comment) => {
                    this.appMainService.isHideSpinner('updateStage');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Stage updated successfully...' });
                    this.commentForm.reset();
                    this.commentSaved.emit({
                        formType: this.formType,
                        comment: oneCase,
                        objectRecordId: this.currentCase?.id
                    });
                    this.app.getAllObjects();
                    //this.app.getAllActivityLog("thisyear", "allactivity", 1, 10, "", true, true);
                    this.disabledAddComment = false;
                },
                err => {
                    this.appMainService.isHideSpinner('updateStage');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.errors.Comment[0] })
                    this.disabledAddComment = false;
                    this.isSubmit = false;
                }
            );
        }
    }

    onselectStage(values) {
        let value = [];
        if (this.commentForm.value.stageId) {
            value = this.commentForm.value.stageId.id == this.closeLostStage.id ?
                this.closeLostUnQualifiedReasons.filter(x => x.isDefault) :
                this.closeWonQualifiedReasons.filter(x => x.isDefault)
        }
        value = this.tempComment.objectId == 1 ? value : null;
        this.commentForm.patchValue({ reasonId: value });
        this.closeDateTitle = values?.name;
    }

    getResolvedReason(filterResolvedReason = false, objectStageAuditReasons?: any): void {
        this.appMainService.isShowSpinner('getResolvedReasons');

        this.caseConfigService.getAllResolvedReason().then((response) => {
          if (response != null){
            this.resolvedReasons = response.filter((data)=> data?.isActive == true);
            this.resolvedReasonTitle = 'Resolved Reason';
            this.closedReasonTitle = 'Resolved';
            this.showUnResolvedReasonsList = false;
            this.showResolvedReasonsList = true;
            const selectedResolveReson = response ? response.filter(x => x.isDefault == true) : [];
            this.commentForm.patchValue({ resolvedUnresolvedReasons: selectedResolveReson });
            if (filterResolvedReason){
                const reasonObj = objectStageAuditReasons;
                this.resolvedUnresolvedReasonList = this.resolvedReasons.filter((el) => {
                    return reasonObj.some((data) => {
                        return data.reasonId == el.id;
                    })
                });
            }
            this.appMainService.isHideSpinner('getResolvedReasons');

          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail:'Resolved reasons are not loaded' });
            this.appMainService.isHideSpinner('getResolvedReasons');
          }
        },
        (error) => {
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: error.error?.Message == null
                    ? "Error Occured, try again later"
                    : error.error?.Message,
          });
        this.appMainService.isHideSpinner('getResolvedReasons');
        });
    }

    getUnresolvedReason(filterResolvedReason = false, objectStageAuditReasons?: any): void {
        this.appMainService.isShowSpinner('getUnresolvedReasons');

        this.caseConfigService.getAllUnresolvedReason().then((response) => {
          if (response != null){
            this.unResolvedReasons = response.filter((data)=> data?.isActive == true);
            this.unresolvedReasonTitle = 'Unresolved Reason';
            this.closedReasonTitle = 'Unresolved';
            this.showResolvedReasonsList = false;
            this.showUnResolvedReasonsList = true;
            const selectedUnResolveReson = response ? response.filter(x => x.isDefault == true) : [];
            this.commentForm.patchValue({ resolvedUnresolvedReasons: selectedUnResolveReson });
            if (filterResolvedReason){
                const reasonObj = objectStageAuditReasons;
                this.resolvedUnresolvedReasonList = this.unResolvedReasons.filter((el) => {
                    return reasonObj.some((data) => {
                        return data.reasonId == el.id;
                    })
                });
            }
            this.appMainService.isHideSpinner('getUnresolvedReasons');
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail:'Unresolved reasons are not loaded' });
          this.appMainService.isHideSpinner('getUnresolvedReasons');
          }
        },
        (error) => {
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: error.error?.Message == null
                    ? "Error Occured, try again later"
                    : error.error?.Message,
          });
        this.appMainService.isHideSpinner('getUnresolvedReasons');
        });
    }

    onChangeResolvedUnresolvedStage($event): void {
        if ($event.value?.name == "Resolved"){
            this.getResolvedReason();
        }
        else {
            this.getUnresolvedReason();
        }
      let test = $event;
    }

    openUpdateStagePopupChild(id, type) {
        if (id) {
            if(this.currentObjectType == 'Opportunity'){
                this.selectedCase.opportunityStageId = id;
                this.tempComment.objectId = OpportunityModuleId;
            }else{
                this.selectedCase.ticketStageId = id;
                this.tempComment.objectId = CaseModuleId;
            }
            this.commentForm.patchValue({ stageId: id });
            this.nextStageIdToUpdate = id;
        }
        if(id == -1){
            if(this.currentObjectType == 'Opportunity'){
                this.isClosed = true;
                this.nextStageIdToUpdate = -1;
                // this.showResolvedUnresolvedArea = true;
                this._updateClosedObject();
            }else{
                this.getResolvedReason();
                if (this.selectedCase['closedStages']){
                    const data = this.selectedCase['closedStages'];
                    this.resolvedUnresolvedStages = [...data];
                    const selectedStage = data?.filter(x => x?.name == "Resolved") || [];
                    this.commentForm.patchValue({ resolvedUnresolvedStage: selectedStage[0] });
                }
                this.showResolvedUnresolvedArea = true;
                this.isClosed = false;
            }
        }else{
            this.isClosed = false;
            this.showResolvedUnresolvedArea = false;
        }
    }

    getUserList() {
        this.userService.getUsers(this.app.companyId).then(users => {
            if (users && users.length) {
                this.ownerList = users.sort((a, b) => a.name.localeCompare(b.name));
            }
        });
    }

    getSettingsData() {
      this.crmSettingsService.getCrmSettingFieldsList().subscribe({
        next: (response: CrmSettingModel[]) => {
          this.leadOwnerSettings = response?.find(data => data?.moduleId == this.tempComment?.objectId && (data?.code == StageOnwerSettingCode?.leadOwnerSttingCode || StageOnwerSettingCode?.accountOwnerSttingCode || StageOnwerSettingCode?.opportunityOwnerSttingCode || StageOnwerSettingCode?.casesOwnerSttingCode));
        },
        error: (error) => {}
      });
    }

    onSelectStageOwner(value) {
        if (value) {
            this.commentForm.patchValue({ stageOwnerId: value })
        }
    }
}
